// extracted by mini-css-extract-plugin
export var md = "_2y-4";
export var semantic = "_2y-5";
export var sm = "_2y-3";
export var text = "_2y-6";
export var toggleInput = "_2y-0";
export var toggleSwitch = "_2y-1";
export var xs = "_2y-2";